import { Flex } from 'antd';
import { useTranslation } from 'react-i18next';

import HeaderCard from 'components/HeaderCard';
import ProtectedResource from 'components/RoleBasedAccessControl/ProtectedResource';
import RBCountryFilter from 'components/UniversalFilters/RBCountryFilter';
import SeasonIndexFilter from 'components/UniversalFilters/SeasonIndexFilter';

import { PlantingGroupStageWidget } from './components/planting-group-stages';
import { SeasonProgressWidget } from './components/season-progress';
import { SeasonSummaryWidget } from './components/season-summary-table';
import { TeamProgressWidget } from './components/team-progress';

import useSeasonOverviewFilters from './hooks/useSeasonOverviewFilters';

import { ROLE_GROUPS } from 'utils/constants';

import './style.scss';

const SeasonOverview = () => {
  const { t } = useTranslation();
  const { filters, setCountry, setSeasonIndex } = useSeasonOverviewFilters();

  return (
    <Flex vertical className="season-overview" gap={16}>
      <HeaderCard
        headerLabel={t('seasonOverview.header')}
        headerInfo={t('seasonOverview.subHeader')}
        filters={
          <Flex wrap="wrap" gap={16}>
            <RBCountryFilter
              selectedCountry={filters.country!}
              onChange={setCountry}
            />
            <SeasonIndexFilter
              country={filters.country!}
              seasonIndex={filters.seasonIndex!}
              setSeasonIndex={setSeasonIndex}
            />
          </Flex>
        }
      />
      <Flex gap={16} wrap="wrap">
        <SeasonProgressWidget
          country={filters.country}
          seasonTypeId={filters.seasonIndex}
        />
        <PlantingGroupStageWidget
          country={filters.country}
          seasonTypeId={filters.seasonIndex}
        />
      </Flex>

      <ProtectedResource permission={'matrix:read'}>
        <TeamProgressWidget
          country={filters.country}
          seasonTypeId={filters.seasonIndex}
        />
      </ProtectedResource>

      <SeasonSummaryWidget
        country={filters.country!}
        seasonTypeId={filters.seasonIndex}
      />
    </Flex>
  );
};

export default SeasonOverview;
